export const LOADER_HIDDEN = 'LOADER_HIDDEN';

export const loaderHidden = payload => dispatch =>
  dispatch({
    type: LOADER_HIDDEN,
    payload,
  });
